export function createSVGIcon(
  width = 100,
  height = 100,
  count = 1,
  strokeWidth = 2,
  strokeColor = "#00FFB4",
  fillColor = "rgba(255,255,255,0.5)",
  textColor = "#00FFB4"
) {
  return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
            <g>
                <circle cx="50" cy="50" r="${
                  50 - strokeWidth
                }" stroke="${strokeColor}" 
                stroke-width="${strokeWidth}" fill="${fillColor}" text-align="center"/>
                <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="PingFangSC-Regular, PingFang SC" font-size="30" fill="${textColor}">
                ${count}
                </text>
          </g>
        </svg>`
}

export function svgToDataURL(svg: string) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
